import { render, staticRenderFns } from "./ChoiceModal.vue?vue&type=template&id=ae5dee94&scoped=true"
import script from "./ChoiceModal.vue?vue&type=script&lang=js"
export * from "./ChoiceModal.vue?vue&type=script&lang=js"
import style0 from "./ChoiceModal.vue?vue&type=style&index=0&id=ae5dee94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5dee94",
  null
  
)

export default component.exports